import Vue from "vue";
import Router from "vue-router";

/* Views aqui */
import Login from "./views/Login.vue";
import RecoverPassword from "@/views/RecoverPassword.vue";
import ResetPassword from "@/views/ResetPassword.vue";

import Home from "./views/Home.vue";

import { produtosRoutes } from "@/routes/Produtos";
import { formaPagamentoRoutes } from "@/routes/FormaPagamento";
import { orcamentosRoutes } from "@/routes/Orcamento";
import { vendasRoutes } from "@/routes/Vendas";
import { empresasRoutes } from "@/routes/Empresas";
import { pedidosCompraRoutes } from "@/routes/PedidoCompra";
import { entradaMercadoriaRoutes } from "@/routes/EntradaMercadoria";
import { unidadeMedidaRoutes } from "@/routes/UnidadeMedida";
import Funcionarios from "@/pages/funcionario/Listar";
import Perfil from "@/pages/perfil/Listar";
import Permissao from "@/pages/perfil/permissao/Listar";
import Cargo from "@/pages/cargo/Listar";
import Contato from "@/pages/contato/Listar";
import Estoque from "@/pages/estoque/Listar";
import TransferenciaEstoque from "@/pages/estoque/transferencia/Listar";
import Banco from "@/pages/banco/Listar";
import ContaPagar from "@/pages/financeiro/contaPagar/Listar";
import ContaReceber from "@/pages/financeiro/contaReceber/Listar";
import GrupoFinanceiro from "@/pages/financeiro/grupo/Listar";
import LancamentoBancario from "@/pages/financeiro/lancamentoBancario/Listar";
import FluxoCaixa from "@/pages/financeiro/fluxo-caixa/Listar";
import Senha from "@/pages/funcionario/Senha";
import GrupoPermissao from "@/pages/perfil/grupoPermissao/Listar";
import { relatorioRoutes } from "@/routes/Relatorio";
import { logRoutes } from "@/routes/Log";
import { ordensDeServicoRoutes } from "@/routes/ordensDeServico";
import ModeloTanque from "@/pages/modeloTanque/Listar";
import NCMListar from "@/pages/ncm/Listar"
import PosVendaListar from "@/pages/crm/posVenda/Listar"
import CrmProposta from "@/pages/crm/proposta/Listar"
import PesquisaSatisfacao from "@/pages/crm/pesquisaSatisfacao/Listar"
import EtiquetaListar from "@/pages/etiqueta/Listar"

Vue.use(Router);

export const router = new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/recuperar-senha",
      name: "recoverPassword",
      component: RecoverPassword,
    },
    {
      path: "/reset-password/:token",
      name: "resetPassword",
      component: ResetPassword,
      props: true,
    },
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        {
          path: "/funcionario/listar",
          name: "funcionarios",
          component: Funcionarios,
        },
        {
          path: "/senha",
          name: "senha",
          component: Senha,
        },
        {
          path: "/contatos",
          name: "contatos",
          component: Contato,
        },
        {
          path: "/cargos",
          name: "cargos",
          component: Cargo,
        },
        {
          path: "/estoques",
          name: "estoques",
          component: Estoque,
        },
        {
          path: "/estoques/transferencias",
          name: "transferenciasEstoques",
          component: TransferenciaEstoque,
        },
        {
          path: "/perfis/listar",
          name: "perfis",
          component: Perfil,
        },
        {
          path: "/bancos",
          name: "bancos",
          component: Banco,
        },
        {
          path: "/permissoes/listar",
          name: "permissoes",
          component: Permissao,
        },
        {
          path: "/permissoes/grupos/listar",
          name: "gruposPermissoes",
          component: GrupoPermissao,
        },
        {
          path: "/financeiro/contas-pagar",
          name: "contasPagar",
          component: ContaPagar,
        },
        {
          path: "/financeiro/contas-receber",
          name: "contasReceber",
          component: ContaReceber,
        },
        {
          path: "/financeiro/categorias",
          name: "gruposFinanceiro",
          component: GrupoFinanceiro,
        },
        {
          path: "/financeiro/lancamentos-bancarios",
          name: "lancamentosBancarios",
          component: LancamentoBancario,
        },
        {
          path: "/financeiro/fluxo-caixa",
          name: "fluxoCaixa",
          component: FluxoCaixa,
        },
        {
          path: "/modelos-tanques",
          name: "modelosTanques",
          component: ModeloTanque,
        },
        {
          path: "/ncm",
          name: "NCMListar",
          component: NCMListar,
        },
        {
          path: "/pos-venda",
          name: "posVendaListar",
          component: PosVendaListar,
        },
        {
          path: "/propostas",
          name: "crmPropostaListar",
          component: CrmProposta,
        },
        {
          path: "/pesquisas-satifacao",
          name: "pesquisaSatisfacaoListar",
          component: PesquisaSatisfacao,
        },
        {
          path: "/etiquetas",
          name: "etiquetaListar",
          component: EtiquetaListar,
        },
        ...vendasRoutes,
        ...produtosRoutes,
        ...formaPagamentoRoutes,
        ...orcamentosRoutes,
        ...empresasRoutes,
        ...pedidosCompraRoutes,
        ...entradaMercadoriaRoutes,
        ...unidadeMedidaRoutes,
        ...relatorioRoutes,
        ...logRoutes,
        ...ordensDeServicoRoutes,
      ],
    },
  ],
});

export default {};
